module.exports = __webpack_public_path__ + "img/mobile/Background/blast_background_ls@2.25x.jpg?1.1.2";